module.exports = __webpack_public_path__ + "static/media/team2.b1e4f497.png";